import React from 'react';
import PropTypes from 'prop-types';

export default class NavigationComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            showModals: {}
        };

        this.pushRoute = this.pushRoute.bind(this);
        this.pushRouteWithProps = this.pushRouteWithProps.bind(this);

        this.toggleModals = this.toggleModals.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
    }

    static contextTypes = {
        router: PropTypes.object
    };

    pushRoute(route, passProps) {
        this.context.router.history.push(route);
    }

    pushRouteWithProps(route, passProps) {
        this.context.router.history.push(route, passProps);
    }

    toggleModals(modals) {
        let updatedModals = {};
        modals.forEach(modal => updatedModals[modal] = !this.state.showModals[modal]);
        this.setState({
            showModals: {
                ...this.state.showModals,
                ...updatedModals
            }
        });
    }

    toggleModal(modal) {
        this.setState({ showModals: { ...this.state.showModals, [modal]: !this.state.showModals[modal] } });
    }
}


// WEBPACK FOOTER //
// ./src/components/commonComponents/util/NavigationComponent.jsx